import { useEffect } from 'react';

/**
 * useScript is a hook for appending script elements to the body of the document
 * @param {string} appendTo where in the document will the script be appended to, e.g. head, body
 * @param {object} attributes script element attributes such as src, type, text and async
 * @param {boolean} shouldLoad allows to conditionally apend/remove the script
 */

export const useScript = (appendTo, attributes, shouldLoad = true) => {
  useEffect(() => {
    if (shouldLoad) {
      const script = document.createElement('script');
      Object.assign(script, attributes);
      document[appendTo].appendChild(script);

      return () => {
        document[appendTo].removeChild(script);
      };
    }
  }, [attributes, shouldLoad]);
};
